import { createClient } from '@supabase/supabase-js';
import type { Database } from '../types/supabase';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  // This module is imported eagerly (no code-splitting), so throwing here
  // used to fire before ReactDOM ever rendered - a misconfigured env var
  // blanked the entire site with no error boundary able to catch it.
  console.error('Missing Supabase environment variables (VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY) - auth and data features will not work.');
}

export const supabase = createClient<Database>(
  supabaseUrl || 'https://placeholder.supabase.co',
  supabaseAnonKey || 'placeholder-anon-key'
);

export const apiBaseUrl = import.meta.env.VITE_API_URL || '';

export const signInWithOAuth = async (provider: 'github' | 'google' | 'azure') => {
  const { data, error } = await supabase.auth.signInWithOAuth({
    provider,
    options: {
      redirectTo: `${window.location.origin}/oauth/callback`,
    },
  });
  return { data, error };
};

